import { useBusinessCount as n } from "./useBusinessCount.js";
import { useBusinesses as u } from "./useBusinesses.js";
const r = () => {
  const {
    query: s
  } = n(), {
    query: e
  } = u();
  return s.isLoading || e.isLoading;
};
export {
  r as useIsLoadingBusinessContent
};
